module.exports = __webpack_public_path__ + "img/logouticon.3f8fc51a.svg";